(() => {
  if (window.foAnnouncementRotation) return;
  const instances = new Map();
  function init(root = document) {
    root.querySelectorAll('[data-announcement-rotate]').forEach(bar => {
      if (instances.has(bar)) return;
      const messages = Array.from(bar.querySelectorAll('[data-announcement-message]'));
      if (messages.length < 2) return;
      let index = 0, timer, hovered = false;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const schedule = () => {
        clearTimeout(timer);
        if (document.hidden || hovered || motion.matches) return;
        timer = setTimeout(() => {
          messages[index].hidden = true;
          index = (index + 1) % messages.length;
          messages[index].hidden = false;
          schedule();
        }, 4000);
      };
      const enter = () => { hovered = true; schedule(); };
      const leave = () => { hovered = false; schedule(); };
      bar.addEventListener('mouseenter', enter);
      bar.addEventListener('mouseleave', leave);
      document.addEventListener('visibilitychange', schedule);
      motion.addEventListener('change', schedule);
      instances.set(bar, () => {
        clearTimeout(timer);
        bar.removeEventListener('mouseenter', enter);
        bar.removeEventListener('mouseleave', leave);
        document.removeEventListener('visibilitychange', schedule);
        motion.removeEventListener('change', schedule);
      });
      schedule();
    });
  }
  window.foAnnouncementRotation = true;
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((cleanup, bar) => {
      if (event.target.contains(bar)) { cleanup(); instances.delete(bar); }
    });
  });
})();